import {
  DashboardIcon,
  // CollaborationsIcon,
  WalletIcon,
  MessageIcon,
  LeaderboardIcon
} from '../common/icon';

export const getNavbarMenu = (t: any) => {
  return [
    {
      label: t('navbar.menu.dashboard', { defaultValue: 'Dashboard' }),
      key: 'dashboard',
      icon: DashboardIcon,
      href: '/'
    },

    // Brand deals navigation is temporarily hidden from the sidebar.
    {
      label: t('navbar.menu.new_wallet', { defaultValue: 'Wallet' }),
      key: 'wallet',
      icon: WalletIcon,
      href: '/campaign/wallet'
    },
    {
      label: t('navbar.menu.leaderboard', { defaultValue: 'Leaderboard' }),
      key: 'leaderboard',
      icon: LeaderboardIcon,
      href: '/leaderboard',
      badge: 'New'
    },
    {
      label: t('navbar.menu.messages', { defaultValue: 'Messages' }),
      key: 'message',
      icon: MessageIcon
    }
  ];
};
